











import StatisticsCardRow from "@/components/utility/StatisticsCardRow.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { SignRequestModule } from "@/store/modules/sign-request.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component } from "vue-property-decorator";
import DocumentTable from "./DocumentTable.vue";
import SignRequestTable from "./SignRequestTable.vue";

@Component({
  components: {
    TheLayoutPortal,
    StatisticsCardRow,
    DocumentTable,
    SignRequestTable
  }
})
export default class SignRequestTableView extends PartnerFallbackMixin {
  loading = false;

  get allSignatureRequests() {
    return SignRequestModule.requests;
  }

  async mounted() {
    try {
      this.loading = true;
      await this.trySetByRouteOrDefault();

      const promises: Promise<void>[] = [];

      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN)) {
        promises.push(DocumentModule.getAll({ partnerId: PartnerModule.partner._id }));
      }

      await Promise.all(promises);
    } catch (e) {
      this.$toast.error((e as any).message);
      this.$log.error(e);
    } finally {
      this.loading = false;
    }
  }
}
